/**
 * Single source of truth for site identity, navigation, and contact links.
 * Update placeholders here before publishing — components adapt automatically.
 */

export const site = {
  name: "Gian Franco Jadan",
  initials: "GJ",
  role: "Systems Engineer",
  roleDetail: "IT Infrastructure · Networking · Automation",
  location: "New York, NY",
  tagline: "I design, build, and optimize the systems everything else depends on.",
  description:
    "Systems engineer and IT infrastructure professional in New York — designing, troubleshooting, and integrating complex systems across infrastructure, networks, software, automation, AI, and data.",
  /** Production domain — DNS/deployment handled by the owner. */
  url: "https://gianfjadan.com",
  /** Public contact details. */
  email: "gianjadan@gmail.com",
  linkedin: "https://www.linkedin.com/in/gian-jadan-a73295192/",
  github: "",
  resumePdf: "/resume.pdf",
} as const;

/** Hash-anchored homepage sections rendered in the main nav. */
export const sections = [
  { id: "about", label: "About" },
  { id: "method", label: "Method" },
  { id: "experience", label: "Experience" },
  { id: "skills", label: "Skills" },
  { id: "contact", label: "Contact" },
] as const;

/** Standalone routes rendered in the main nav. */
export const routes = [
  { href: "/projects", label: "Projects" },
  { href: "/resume", label: "Resume" },
] as const;

/** The through-line: how the work connects across layers. */
export const domainChain = [
  "Engineering",
  "Infrastructure",
  "Networks",
  "Software",
  "Automation",
  "AI",
  "Data",
] as const;